import type { ClientsFilters } from "./clients-state"
import { EMPTY_FILTERS } from "./clients-state"

/**
 * Состояние списка клиентов В АДРЕСЕ.
 *
 * Поиск и фильтры живут в адресной строке, а не в памяти компонента, и это не
 * техническая мелочь: выборку «не были больше трёх месяцев, мастер — Анна» собирают
 * для обзвона и пересылают коллеге в чат. Ссылка, которая открывает пустой список,
 * заставляет собирать её заново — по памяти, с ошибками.
 *
 * Разбор ЩАДЯЩИЙ: чужой или устаревший параметр не роняет экран, а игнорируется.
 * Адрес приходит снаружи — из чата, из закладки, из истории браузера.
 */

export interface ClientsSearch {
  readonly q?: string | undefined
  /** «Не были больше 3 месяцев». */
  readonly stale?: boolean | undefined
  /** «Ограничение записи». */
  readonly blocked?: boolean | undefined
  /** «Неявки». */
  readonly noshow?: boolean | undefined
  /** «Мастер последнего визита». */
  readonly master?: string | undefined
  readonly sort?: "last_visit" | "name" | "visits" | undefined
}

function readBoolean(value: unknown): boolean | undefined {
  if (value === true || value === "true" || value === "1") return true
  return undefined
}

function readString(value: unknown): string | undefined {
  return typeof value === "string" && value.length > 0 ? value : undefined
}

export function parseClientsSearch(search: Record<string, unknown>): ClientsSearch {
  const sort = readString(search["sort"])
  return {
    q: readString(search["q"]),
    stale: readBoolean(search["stale"]),
    blocked: readBoolean(search["blocked"]),
    noshow: readBoolean(search["noshow"]),
    master: readString(search["master"]),
    sort: sort === "name" || sort === "visits" || sort === "last_visit" ? sort : undefined,
  }
}

export function filtersOf(search: ClientsSearch): ClientsFilters {
  return {
    ...EMPTY_FILTERS,
    search: search.q ?? "",
    staleOnly: search.stale === true,
    blockedOnly: search.blocked === true,
    noShowOnly: search.noshow === true,
    employeeId: search.master ?? null,
  }
}

/** Пустой адрес: «Сбросить фильтры» обязан снимать ВСЁ, а не только видимые чипы. */
export const CLEARED_SEARCH: ClientsSearch = {
  q: undefined,
  stale: undefined,
  blocked: undefined,
  noshow: undefined,
  master: undefined,
  sort: undefined,
}
